<template>
    <div class="content-wrap">
        <resultFilter></resultFilter>
        <div class="overview-wrap">
            <div class="overview-title">项目概览</div>
            <div class="card-list">
                <div class="card-item">
                    <div class="card-item-name">代理商</div>
                    <div class="card-item-count">229</div>
                </div>
                <div class="card-item">
                    <div class="card-item-name">签单手</div>
                    <div class="card-item-count">229</div>
                </div>
                <div class="card-item">
                    <div class="card-item-name">项目经理</div>
                    <div class="card-item-count">229</div>
                </div>
            </div>
            <div class="radio-wrap" style="border: none">
                <div class="radio-item">
                    <img :src="isFollow === 'sl' ? selectImg : noSelectImg" alt="" @click="isFollow = 'sl'">
                    <div>数量</div>
                </div>
                <div class="radio-item">
                    <img :src="isFollow === 'zb' ? selectImg : noSelectImg" alt="" @click="isFollow = 'zb'">
                    <div>占比</div>
                </div>
            </div>
            <div class="check-more" @click="checkMore">点击查看更多</div>
        </div>
        <div class="detailed-wrap">
            <div class="delivery-wrap">
                <div class="overview-title">交付概况</div>
                <div ref="deliveryChart" id="delivery"></div>
                <div class="radio-wrap" style="border: none">
                    <div class="radio-item">
                        <img :src="isDelivery === 'tb' ? selectImg : noSelectImg" alt="" @click="deliveryChange('tb')">
                        <div>同比</div>
                    </div>
                    <div class="radio-item">
                        <img :src="isDelivery === 'hb' ? selectImg : noSelectImg" alt="" @click="deliveryChange('hb')">
                        <div>环比</div>
                    </div>
                </div>
            </div>
            <div class="cycle-wrap">
                <div class="overview-title">交付周期</div>
                <div class="cycle-charts">
                    <div class="cycle-charts-pie-wrap">
                        <div id="cycle-charts-pie"></div>
                        <div class="cycle-charts-pie-text">平均完工周期</div>
                    </div>
                    <div id="cycle-charts-bar"></div>
                </div>
            </div>
            <div class="supervisor-wrap">
                <div class="overview-title">监理概况</div>
                <div class="supervisor-charts">
                    <div class="supervisor-pie-wrap">
                        <div id="supervisor-pie1"></div>
                        <div class="supervisor-pie-title">隐蔽工程监理</div>
                    </div>
                    <div class="supervisor-pie-wrap">
                        <div id="supervisor-pie2"></div>
                        <div class="supervisor-pie-title">调试工程监理</div>
                    </div>
                </div>
                <div class="radio-wrap" style="border: none">
                    <div class="radio-item">
                        <img :src="isSupervisor === 'tb' ? selectImg : noSelectImg" alt="" @click="supervisorChange('tb')">
                        <div>同比</div>
                    </div>
                    <div class="radio-item">
                        <img :src="isSupervisor === 'hb' ? selectImg : noSelectImg" alt="" @click="supervisorChange('hb')">
                        <div>环比</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="export-btn">一键导出</div>
    </div>
</template>

<script>
    import resultFilter from '@/components/hvac/performance/project/resultfilter.vue'
    import {fetchVerifyAuthForB} from '@/libsV2/havc';
    export default {
        name: "index",
        components: {
            resultFilter
        },
        data() {
            return {
                isFollow: 'sl',
                isDelivery: 'tb',
                isSupervisor: 'tb',
                selectImg: require('@/assets/images/result/select.png'),
                noSelectImg: require('@/assets/images/result/noSelect.png'),
                deliveryData1: [150, 230, 224, 218, 135, 147, 260],
                deliveryData2: [50, 20, 224, 28, 35, 14, 60],
            }
        },
        mounted () {
            let that = this;
            fetchVerifyAuthForB(() => {
                that.createDeliveryLine()
                that.createCycleBar()
                that.createCyclePie()
                that.createSupervisorPie1()
                that.createSupervisorPie2()
            });
        },
        methods: {
            // 交付概况切换
            deliveryChange(type) {
                this.isDelivery = type
                for (let i = 0; i < 7; i++) {
                    this.deliveryData1[i] = Math.floor(Math.random() * 100)
                    this.deliveryData2[i] = Math.floor(Math.random() * 100)
                }
                this.createDeliveryLine()
            },
            // 监理概况切换
            supervisorChange(type) {
                this.isSupervisor = type

            },
            createDeliveryLine() {
                let strIngt = this.$refs.deliveryChart;
                if(!strIngt) return;
                const CHARTS = this.$echarts.init(strIngt)
                // const CHARTS = this.$echarts.init(document.getElementById("delivery"))
                const OPTIONS = {
                    grid: {
                        y: '19%',
                        y2: '11%'
                    },
                    legend: {
                        data:['已完工项目','数据2'],
                    },
                    color: ['#73A0FA', '#73DEB3'],
                    xAxis: {
                        type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '已完工项目',
                            data: this.deliveryData1,
                            type: 'line'
                        },
                        {
                            name: '数据2',
                            data: this.deliveryData2,
                            type: 'line'
                        }
                    ]
                }
                CHARTS.setOption(OPTIONS)
            },
            createCycleBar() {
                const CHARTS = this.$echarts.init(document.getElementById("cycle-charts-bar"));
                const OPTIONS = {
                    color: ['#8EA3EC'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value',
                        splitLine: {
                            show: true
                        },
                        axisLabel : {
                            textStyle: {
                                color: '#858585'
                            }
                        },
                    },
                    yAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                color: 'rgba(0, 0, 0, 0.15)'
                            }
                        },
                        axisLabel : {
                            textStyle: {
                                color: '#858585'
                            }
                        },
                        data: ['进场定位', '隐蔽工程', '设备安装', '系统调试']
                    },
                    series: [
                        {
                            name: '2011',
                            type: 'bar',
                            data: [5, 9, 4, 6]
                        }
                    ]
                };
                CHARTS.setOption(OPTIONS)
            },
            createCyclePie() {
                const CHARTS = this.$echarts.init(document.getElementById("cycle-charts-pie"));
                const OPTIONS = {
                    tooltip: {
                        trigger: 'item'
                    },
                    color: ['rgba(91, 143, 249, 0.85)'],
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['60%', '100%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '40',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 10, name: 'Search Engine', label: { show: true, formatter:'{c}' + '天', textStyle: { color: '#252525', fontSize: '22px', fontWeight: 'bold' } } }
                            ]
                        }
                    ]
                };
                CHARTS.setOption(OPTIONS)
            },
            createSupervisorPie1() {
                const CHARTS = this.$echarts.init(document.getElementById("supervisor-pie1"));
                const OPTIONS = {
                    tooltip: {
                        trigger: 'item'
                    },
                    color: ['rgba(91, 143, 249, 0.85)', '#F1F1F1'],
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['60%', '100%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '40',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 10, name: 'Search Engine', label: { show: true, formatter:'{d}%', textStyle: { color: '#252525', fontSize: '22px', fontWeight: 'bold' } } },
                                { value: 10, name: 'Direct' }
                            ]
                        }
                    ]
                };
                CHARTS.setOption(OPTIONS)
            },
            createSupervisorPie2() {
                const CHARTS = this.$echarts.init(document.getElementById("supervisor-pie2"));
                const OPTIONS = {
                    tooltip: {
                        trigger: 'item'
                    },
                    color: ['rgba(249, 178, 91, 0.85)', '#F1F1F1'],
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['60%', '100%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '40',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 90, name: 'Search Engine', label: { show: true, formatter:'{d}%', textStyle: { color: '#252525', fontSize: '22px', fontWeight: 'bold' } } },
                                { value: 10, name: 'Direct' }
                            ]
                        }
                    ]
                };
                CHARTS.setOption(OPTIONS)
            },
            checkMore() {
                this.$router.push({ path: '/performance/project/list' })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        background: #F0F4F1;

        .overview-wrap {
            width: 93.6%;
            margin: 20px auto 24px;
            background: #fff;
            padding: 28px 24px 32px;
            border-radius: 12px;


            .card-list {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 24px 0;

                .card-item {
                    width: 31%;
                    height: 200px;
                    background: #F7F7F7;
                    border-radius: 16px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    align-items: center;

                    .card-item-name {
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #858585;
                        line-height: 40px;
                    }

                    .card-item-count {
                        font-size: 48px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #318544;
                        line-height: 66px;
                    }
                }
            }

            .check-more {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: center;
                color: #444444;
                line-height: 34px;
            }
        }

        .detailed-wrap {
            width: 93.6%;
            margin: 0 auto;
            padding: 28px 24px 42px;
            border-radius: 12px;
            background: #fff;

            .delivery-wrap {
                border-bottom: 2px dashed #F1F1F1;

                #delivery {
                    width: 100%;
                    height: 348px;
                }
            }

            .cycle-wrap {
                border-bottom: 2px dashed #F1F1F1;
                margin-top: 30px;

                .cycle-charts {
                    width: 100%;
                    padding: 40px 0;
                    display: flex;
                    justify-content: space-between;

                    .cycle-charts-pie-wrap {
                        width: 31%;
                        height: 272px;

                        #cycle-charts-pie {
                            width: 100%;
                            height: 200px;
                        }
                        .cycle-charts-pie-text {
                            margin-top: 32px;
                            font-size: 24px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            text-align: center;
                            color: #252525;
                            line-height: 32px;
                        }
                    }

                    #cycle-charts-bar {
                        width: 63%;
                        height: 272px;
                    }
                }
            }

            .supervisor-wrap {
                margin-top: 30px;

                .supervisor-charts {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    margin: 46px 0 0;

                    .supervisor-pie-wrap {
                        width: 31%;

                        #supervisor-pie1, #supervisor-pie2 {
                            width: 100%;
                            height: 200px;
                        }
                        .supervisor-pie-title {
                            margin-top: 24px;
                            font-size: 24px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            text-align: center;
                            font-weight: 400;
                            color: #858585;
                            line-height: 34px;
                        }
                    }


                }
            }
        }

        .export-btn {
            width: 93.6%;
            height: 92px;
            margin: 40px auto;
            background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
            border-radius: 12px;

            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            text-align: center;
            color: #FFFFFF;
            line-height: 92px;
        }

        /*公共样式*/
        .overview-title {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #222222;
            line-height: 40px;
        }

        .radio-wrap {
            display: flex;
            padding: 30px 0;
            border-bottom: 2px dashed #F1F1F1;
            justify-content: space-evenly;
            align-items: center;

            .radio-item {
                display: flex;
                align-items: center;

                img {
                    width: 36px;
                    height: 36px;
                    margin-right: 8px;
                }

                div {
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #444444;
                    line-height: 40px;
                }
            }
        }
    }
</style>